// A focused <input type="number"> changes its value when the wheel turns
// over it. That is the browser's behaviour, not ours, and it is wrong
// everywhere it happens here: somebody tabs into an amount, scrolls the
// dialog to read the rest of the form, and the figure under the pointer
// quietly moves. On a challan or a TDS entry that is a number nobody typed
// and nobody notices until it is on a return.
//
// Handled once, globally, because there are over a hundred number inputs in
// this app and a fix applied per input is a fix that is missing from the
// next one somebody adds.
//
// Blur rather than preventDefault: stopping the event would also stop the
// page scrolling, which is what the person was actually doing. Blurring
// takes the input out of the wheel's reach and lets the scroll through --
// the value stays put, the page moves, and the only cost is a caret the
// user had already stopped using.
document.addEventListener(
  "wheel",
  (event) => {
    const focused = document.activeElement;
    if (!focused || focused.tagName !== "INPUT" || focused.type !== "number") return;
    // Only when the wheel is over the focused field itself. Scrolling
    // somewhere else on the page while an amount happens to hold focus is
    // not something to interfere with.
    if (event.target !== focused) return;
    focused.blur();
  },
  // Capture, so it runs before the input acts on it; passive, because this
  // never calls preventDefault and saying so lets the browser scroll
  // without waiting on us.
  { passive: true, capture: true },
);
